import { Fragment, useEffect } from "react";
import { Reveal } from "../Reveal";
import { JQRCard } from "./JQRCard";
import { scrollToId } from "../../lib/api";

const TableQR = () => {
  useEffect(() => {
    if (window.location.hash !== "#dosificacion") return undefined;
    const t = setTimeout(() => scrollToId("dosificacion"), 900);
    return () => clearTimeout(t);
  }, []);
  return (
    <JQRCard url={`${window.location.origin}/#dosificacion`} title="QR tabla Jungle" testid="schedule-qr" fileName="jungle-tabla-cultivo"
      caption="Escanéalo para abrir esta tabla de cultivo en el móvil. Descárgalo e imprímelo." />
  );
};

// Cuadrante de riego Jungle (official sheet, 100 L): doses stored in mL/L (= ml per 100 L / 100). null = dose pending.
export const COLS = ["C1", "C2", "C3", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8"];
export const ROWS = [
  ["grow", "Grow", "/img/water-giraffe.webp", { C1: "1,5", C2: "2,0", C3: "2,0" }],
  ["a-bloom", "A Bloom", "/img/water-toucan.webp", { F1: "1,0", F2: "4,0" }],
  ["b-bloom", "B Bloom", "/img/water-toucan.webp", { F3: "4,0", F4: "4,0", F5: "4,0", F6: "4,0", F7: "4,0" }],
  ["pk-065", "PK", "/img/water-elephant.webp", { F3: "1,0", F4: "2,0", F5: "2,0", F6: "2,0", F7: "2,0" }],
  ["bongo-bloom", "Bongo Bloom", "/img/water-monkey.webp", { F3: "0,3", F4: "0,3", F5: "0,3", F6: "0,3", F7: "0,3" }],
  ["compact", "Compact", "/img/water-rock.webp", { F5: "0,5–1,5", F6: "0,5–1,5", F7: "0,5–1,5" }],
];
export const ANIMAL = { grow: "Jirafa", "a-bloom": "Tucán", "b-bloom": "Tucán", "pk-065": "Elefante", "bongo-bloom": "Mono", compact: "Roca" };
export const per100 = (v) => `${v.split("–").map((x) => Math.round(parseFloat(x.replace(",", ".")) * 100)).join("–")} ml`;
const NPK = [["Grow", 9, 6, 6], ["A Bloom", 2, 8, 9], ["B Bloom", 2, 10, 12], ["PK", 0, 5.2, 6.5], ["Bongo Bloom", 0, 6, 8], ["Compact", 0, 0, 25]];

const Cell = ({ className = "", children, testid }) => (
  <div data-testid={testid} className={`rounded-[10px] bg-[#143823] border border-[#F2B441]/20 p-6 md:p-8 h-full ${className}`}>{children}</div>
);
const Eyebrow = ({ children }) => <p className="font-mono-d text-[11px] tracking-[0.22em] uppercase text-[#8CD05A]">{children}</p>;

export const JSchedule = () => (
  <section id="dosificacion" data-testid="dosing-schedule-section" className="relative py-24 md:py-36">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <Reveal className="mb-12 md:mb-16 grid md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-7">
          <Eyebrow>Cuadrante de riego Jungle · 100 L</Eyebrow>
          <h2 className="font-serif-d font-black text-5xl md:text-7xl leading-[0.92] tracking-tight mt-6">
            Semana a semana, <span className="italic font-semibold text-[#F2B441]">cada animal a su riego.</span>
          </h2>
        </div>
        <div className="md:col-span-4 md:col-start-9 space-y-5">
          <p className="text-[#C9D6C2] leading-relaxed">Riego lunes, miércoles y viernes con la misma dosis en cada riego. Domingo de descanso. Dosis por 100 L de solución (entre paréntesis, por litro). C = crecimiento, F = floración.</p>
          <TableQR />
        </div>
      </Reveal>

      <Reveal>
        <div data-lenis-prevent className="overflow-x-auto rounded-[10px] label-frame bg-[#143823] p-2">
          <div data-testid="feeding-table" className="min-w-[980px] grid grid-cols-[190px_repeat(11,minmax(0,1fr))] text-sm">
            <div className="p-3" />
            <div className="col-span-3 p-2 text-center font-mono-d text-[11px] tracking-[0.2em] text-[#0E2A1C] bg-[#8CD05A] rounded-t-[6px]">CRECIMIENTO</div>
            <div className="col-span-8 p-2 text-center font-mono-d text-[11px] tracking-[0.2em] text-[#0E2A1C] bg-[#F2B441] rounded-t-[6px] ml-1">FLORACIÓN</div>
            <div className="p-3" />
            {COLS.map((c) => <div key={c} className="p-3 text-center font-mono-d text-xs text-[#C9D6C2] border-b border-[#F2B441]/20">{c === "F8" ? "F8 · Lavado" : c}</div>)}
            {ROWS.map(([id, name, img, doses]) => (
              <Fragment key={id}>
                <div data-testid={`schedule-row-${id}`} className="flex items-center gap-2 p-2 border-b border-[#F6EEDC]/10">
                  <img src={img} alt={`${ANIMAL[id]} regando con ${name}`} className="w-12 h-12 object-contain shrink-0 drop-shadow-[0_6px_10px_rgba(0,0,0,0.35)]" />
                  <span className="leading-tight"><span className="block font-label text-base text-[#F6EEDC]">{name}</span>
                    <span className="block font-mono-d text-[10px] uppercase tracking-[0.14em] text-[#8CD05A]">{ANIMAL[id]}</span></span>
                </div>
                {doses === null ? (
                  <div className="col-span-10 p-3 border-b border-[#F6EEDC]/10 flex items-center justify-center text-xs text-[#C9D6C2] font-mono-d">Por definir · dosis pendiente</div>
                ) : COLS.slice(0, 10).map((c) => (
                  <div key={c} className="p-2 border-b border-[#F6EEDC]/10 grid place-items-center">
                    {doses[c] ? (
                      <span data-testid={`dose-${id}-${c}`} className="text-center rounded-[8px] bg-[#F2B441]/15 border border-[#F2B441]/50 text-[#F6EEDC] font-mono-d text-xs px-2 py-1 whitespace-nowrap leading-tight">
                        {per100(doses[c])}<span className="block text-[10px] text-[#C9D6C2]">({doses[c]}/L)</span>
                      </span>
                    ) : <span className="w-1 h-1 rounded-full bg-[#F6EEDC]/20" />}
                  </div>
                ))}
                {id === "grow" && (
                  <div className="row-span-6 p-2 grid place-items-center text-center border-b border-[#F6EEDC]/10 bg-[#5B7FE0]/15 rounded-[6px] ml-1">
                    <span className="font-mono-d text-xs text-[#8FB0FF]">Solo agua<br />(lavado)</span>
                  </div>
                )}
              </Fragment>
            ))}
            <div className="p-3 font-label text-[#F6EEDC]">Riegos</div>
            {COLS.map((c) => (
              <div key={c} className="p-2 text-center font-mono-d text-[11px] text-[#8FB0FF] whitespace-nowrap">{c === "F8" ? "Solo agua" : "L · X · V"}</div>
            ))}
          </div>
        </div>
        <p className="text-[#C9D6C2] text-xs mt-4">Notas: mide la EC del agua de partida (la tabla se calculó con EC 0,6) y adapta las dosis. PK y Compact pueden aplicarse juntos. Compact: 0,5–1,5 mL/L (50–150 ml por 100 L) según su ficha técnica, de F5 a F7 en cada riego.</p>
      </Reveal>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-12 gap-4">
        <Reveal className="md:col-span-7">
          <Cell testid="bento-npk">
            <Eyebrow>Composición garantizada</Eyebrow>
            <p className="font-serif-d font-black text-3xl mt-2 mb-6">N · P · K de cada fórmula</p>
            <div className="space-y-4">
              {NPK.map(([n, N, P, K]) => (
                <div key={n} className="grid grid-cols-[110px_1fr_auto] items-center gap-4">
                  <span className="font-label text-sm">{n}</span>
                  <div className="flex h-2.5 gap-0.5 rounded-full overflow-hidden bg-[#0E2A1C]">
                    <span style={{ width: `${N * 3}%` }} className="bg-[#8CD05A]" />
                    <span style={{ width: `${P * 3}%` }} className="bg-[#F2B441]" />
                    <span style={{ width: `${K * 3}%` }} className="bg-[#5B7FE0]" />
                  </div>
                  <span className="font-mono-d text-xs text-[#C9D6C2] w-[86px] text-right">{N}-{P}-{K}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-5 mt-6 font-mono-d text-[11px] text-[#C9D6C2]">
              <span className="flex items-center gap-2"><i className="w-2.5 h-2.5 rounded-full bg-[#8CD05A]" />N</span>
              <span className="flex items-center gap-2"><i className="w-2.5 h-2.5 rounded-full bg-[#F2B441]" />P₂O₅</span>
              <span className="flex items-center gap-2"><i className="w-2.5 h-2.5 rounded-full bg-[#5B7FE0]" />K₂O</span>
            </div>
          </Cell>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-5">
          <Cell testid="bento-buffer" className="bg-blue-leaves !border-[#F6EEDC]/25">
            <Eyebrow>Efecto Buffer</Eyebrow>
            <p className="font-serif-d font-black text-4xl mt-3 leading-tight">pH automático.</p>
            <p className="text-[#E3EADF] mt-4 leading-relaxed">Grow, A Bloom y B Bloom ajustan el pH de la solución por sí solos: mezcla hasta disolver por completo, sin ácidos ni bases.</p>
          </Cell>
        </Reveal>
        <Reveal className="md:col-span-5">
          <Cell testid="bento-mix-order">
            <Eyebrow>Orden de mezcla</Eyebrow>
            <ol className="mt-5 space-y-4">
              {["Agita los envases antes de usarlos.", "Añade primero B Bloom.", "Después PK y estimuladores.", "Revisa la EC tras cada mezcla."].map((t, i) => (
                <li key={t} className="flex gap-4 items-baseline"><span className="font-label text-2xl text-[#F2B441] w-6">{i + 1}</span><span className="text-[#E3EADF]">{t}</span></li>
              ))}
            </ol>
          </Cell>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-7">
          <div data-testid="bento-harvest" className="relative h-full min-h-[300px] overflow-hidden rounded-[10px] border border-[#F2B441]/20">
            <img src="/img/jungle-bg.webp" alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0E2A1C] via-[#0E2A1C]/85 to-[#0E2A1C]/20" />
            <div className="relative p-6 md:p-10 max-w-md h-full flex flex-col justify-end">
              <Eyebrow>Última semana</Eyebrow>
              <p className="font-serif-d font-black text-4xl mt-3 leading-none">F8: lavado con solo agua.</p>
              <p className="text-[#E3EADF] text-sm mt-4">Hasta F7, B Bloom, PK y Bongo Bloom en cada riego. La última semana se riega solo con agua para limpiar el sustrato antes de cosechar.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
